import React, {  useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend,  Label } from 'recharts';
import moment from 'moment';
import '../../stations/Station.scss';
import { useStoreContext } from '../../../../../store/context';
import { CustomizedAxisTick } from '../chartsPopUpConstants';
import { ONEDAY, getMaxFromSelectedFields, getMinFromSelectedFields } from 'src/store/common';

type SingleVarsProps = {
    all_dates: any[],
    type: string
}

const CustomTooltip:any = (props:any) => {
  const {active, label,payload, timezoneOffset, type, color}=props;
  if (active && payload?.length && label) {
    return (
      <div id="custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block', height: '3.25rem'}}>
          <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
            {type==='hourly' ? (moment(label).utc().utcOffset(timezoneOffset).format("MMM DD, YYYY")): (moment(label).format("MMM DD, YYYY"))}
          </span>
          <span className="hours" style={{fontSize:'.75rem', paddingTop: '0px', paddingBottom: '0px', display:'block'}}>
          {type==='hourly' && moment(label).utc().utcOffset(timezoneOffset).format("HH:mm")}
          </span>
        <svg width="50" height="11" style={{display: 'block', paddingTop: '0.5px'}}>
          <rect width="5" height="5" style={{fill:color}}/>
          <text
            fontSize=".75rem"
            height="5"
            x={10}
            y={10}
          >
          {`${payload[0].value}`}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};
export const SingleVars: React.FC<SingleVarsProps> = ({all_dates, type}) => {
  const [xTicks, setXTicks] = useState<number[]>([]);
  const [state] = useStoreContext();

  const findDomain = () =>{
    const min = Number(getMinFromSelectedFields(all_dates, ['obs', 'forecast'], 5).toFixed(1));
    const max = Number(getMaxFromSelectedFields(all_dates, ['obs', 'forecast']).toFixed(1));
    if(Number.isNaN(min)){
      return([0,1])
    }
    else{
      return[0, max];
    }
  }
  useEffect(()=>{
    if(all_dates.length>1 && all_dates[0]?.offset){
      let ticks:number[]=[];

      if(ticks.length<1){
        if(type==='hourly'){
          let i = moment(all_dates[0].date).utc().utcOffset(all_dates[0].offset).format('MMM DD');
          ticks.push(moment(all_dates[0].date).set('hour', 13).utc().utcOffset(all_dates[0].offset).valueOf())
          let j=0;
          while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
            j=j+1;
            ticks.push(moment(all_dates[0].date - j*ONEDAY).set('hour', 13).utc().utcOffset(all_dates[0].offset).valueOf())
            i = moment(all_dates[0].date - j*ONEDAY).utc().utcOffset(all_dates[0].offset).format('MMM DD')
          }
          setXTicks(ticks)
        }
        else{
          let i = moment(all_dates[0].date).format('MMM DD');
          ticks.push(all_dates[0].date)
          let j=0;
          while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
            j=j+1;
            ticks.push(all_dates[0].date - j*ONEDAY)
            i = moment(all_dates[0].date - j*ONEDAY).utc().utcOffset(all_dates[0].offset).format('MMM DD')
          }
          setXTicks(ticks)

        }
      }
  
    }
  },[all_dates, type]);
  
  return(
    <>
    {all_dates.length>1 &&(
        <LineChart
          width={375}
          height={140}
          data={all_dates}
          margin={{
            top: ( 10),
            right: 10,
            left: 5,
            bottom: 10,
          }}
        >
          <XAxis dataKey="date" interval={0} type="number" tick={<CustomizedAxisTick />} domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" orientation="left" 
            domain={findDomain()} 
            style={{fontSize: '0.7rem',fontFamily: 'serif'}} 
            axisLine={false}>
          <Label
            value={`${state.chartTable.yAxis}`}
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle' }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip timezoneOffset={all_dates[0]?.offset} type={type} color={`${state.chartTable.color}`}/>} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'11px', top:'130px'}} iconType="plainline" iconSize={10}/>
          <Line name={`${state.chartTable.dataLabel}`} type="monotone" yAxisId ="left" dataKey="obs" stroke={`${state.chartTable.color}`} dot={ false} strokeWidth={2}/>
          <Line name={`${state.chartTable.dataLabel} Forecast`} type="monotone" yAxisId = "left" dataKey="forecast" stroke={`${state.chartTable.color}`} dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </LineChart>
    )}
    </>

  );
}